<template>
  <div>
    <a-input
      v-show="editable"
      ref="input"
      :min="0"
      v-model="value"
      @pressEnter="check"
      @blur="check"
      @focus="onFocus"
      style="width: 100%"
    />
    <a-tooltip :title="value" v-show="!editable">{{ value || '' }}</a-tooltip>
  </div>
</template>
<script>
export default {
  name: 'ColumnEditor',
  props: {
    text: [String,Number],
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
      this.$nextTick(()=>{
        this.$refs.input.focus()
      })
    },
    onFocus(e){
      e.target.select()
    }
  }
}
</script>
<style scoped>
</style>

